module.exports = __webpack_public_path__ + "static/img/cp3-coHF1HI2.df280d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/cp3-coHF1HI2.png
// module id = U1uD
// module chunks = 16